import React, { useState, useCallback, Fragment, useEffect } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppTheme } from '../../../styles/AppTheme';
import { FormControl, TextField } from '@material-ui/core';
import { AppButton } from '../../components/AppButton';

export const DateRangePicker = ({ dateStart: initialDateStart, dateEnd: initialDateEnd, onFilter, buttonLabel, hideFilterButton, onDateChange, minDate,}) => {
  const [dateStart, setDateStart] = useState(initialDateStart);
  const [dateEnd, setDateEnd] = useState(initialDateEnd);

  const handleChange = useCallback((event) => {
    const { name, value } = event.target;
    if (name === 'dateStart') setDateStart(value);
    if (name === 'dateEnd') setDateEnd(value);
  }, []);

  const handleFilter = useCallback(() => {
    if (dateStart && dateEnd) {
      onFilter({ dateStart, dateEnd });
    }
  }, [dateStart, dateEnd]);

  useEffect(() => {
    console.log('dateStart, dateEnd', dateStart, dateEnd)
    if(onDateChange) {
      onDateChange({ dateStart, dateEnd })
    }
  }, [dateStart, dateEnd])

  return (
    <Fragment>
      <div className={css(Styles.container)}>
        <form autoComplete='off' className={css(Styles.form)}>
          <div className={css(Styles.filterContainer)}>
            <div className={css(Styles.dateContainer)}>
              <span className={css(Styles.dateLabel)}>Start Day</span>
              <div className={css(Styles.containerItems)}>
                <FormControl className={css(Styles.formControl)} margin='normal' fullWidth>
                  <TextField
                    name='dateStart'
                    placeholder='Start Date'
                    type='date'
                    onChange={handleChange}
                    value={dateStart} inputProps={{ max: dateEnd, min: minDate }}
                    InputLabelProps={{
                      shrink: false, // Prevent label from shrinking to the top
                    }}
                    InputProps={{
                      classes: {
                        underline: css(Styles.noUnderline, Styles.inputStyle),
                      },
                      endAdornment: (
                        <img className={css(Styles.calenderIcon)} src={require('../../../assets/icons/calendar-blue.svg')} />
                      ),
                      startAdornment: null, // Optionally remove any adornments
                    }}

                  />
                </FormControl>
              </div>
            </div>
            <div className={css(Styles.dateContainer)}>
              <span className={css(Styles.dateLabel)}>End Day</span>
              <div className={css(Styles.containerItems)}>
                <FormControl className={css(Styles.formControl)} margin='normal' fullWidth>
                  <TextField
                    name='dateEnd'
                    placeholder='End Date'
                    type='date'
                    onChange={handleChange}
                    value={dateEnd}
                    inputProps={{ min: dateStart || minDate }}
                    InputLabelProps={{
                      shrink: false, // Prevent label from shrinking to the top
                    }}
                    InputProps={{
                      classes: {
                        underline: css(Styles.noUnderline, Styles.inputStyle),
                      },
                      endAdornment: (
                        <img className={css(Styles.calenderIcon)} src={require('../../../assets/icons/calendar-blue.svg')} />
                      ),
                      startAdornment: null, // Optionally remove any adornments
                    }}
                  />
                </FormControl>
              </div>
            </div>
            {!hideFilterButton &&
              <AppButton
                buttonStyle={Styles.button}
                onClick={handleFilter}
                buttonTextStyle={Styles.buttonTextStyle}
                buttonText={buttonLabel || 'Filter'}
              />
            }
          </div>
        </form>
      </div>
    </Fragment>
  );
};

const Styles = StyleSheet.create({
  calenderIcon: {
    position: 'absolute',
    right: '0',
    background: '#fff',
    pointerEvents: 'none'
  },
  filterContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 12,
    alignItems: 'flex-end',
    '@media (max-width: 1024px)': {
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      gap: '8px !important'
    }
  },
  containerItems: {
    flex: 1,
    background: '#fff',
    padding: '0 13px',
    borderRadius: '8px',
    height: '45px',
    maxWidth: 200
  },
  formControl: {
    marginTop: 8
  },
  inputStyle: {
    fontSize: 16,
    color: '#575757'
  },
  noUnderline: {
    '::before': {
      borderBottom: 'none',
    },
    '::hover::before': {
      borderBottom: 'none',
    },
    '::after': {
      borderBottom: 'none',
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 8,
    marginTop: 16,
    maxWidth: AppTheme.viewPort,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    maxWidth: AppTheme.viewPort,
    padding: 0,
    width: '100%',
    borderRadius: 8,
    '@media (max-width: 320px)': {
      maxWidth: 300,
      paddingBottom: 15,
    },
  },
  button: {
    background: '#ffffff',
    color: AppTheme.primaryColor,
    backgroundColor: AppTheme.secondaryBg,
    display: 'inline-flex'
  },
  buttonTextStyle: {
    fontWeight: 550
  },
  dateContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3
  },
  dateLabel: {
    color: '#575757',
    fontSize: 12
  }
});

export default DateRangePicker;



// WEBPACK FOOTER //
// ./src/common/components/charts/DateRangePicker.js